import { errorMessage } from '../../components/Dialogs/TransactionFailedDialog/types';

export const paysafeCardErrorMessages: { [key in string]: string } = {
  '3005': 'The CVV you entered is incorrect. Please double-check and try again.',
  '3006': 'The credit card number you provided has expired. Please use a valid card.',
  '3012':
    'Your transaction was declined because the credit card expiry date is invalid. Please check and enter the correct date.',
  '3017': 'The credit card number you entered is invalid. Please double-check and try again.',
  '3018': 'The bank has asked that you try the transaction again. Please ensure all details are correct.',
  '3019': "The CVV you provided failed verification. Please ensure it's correct and try again.",
  '3020': 'There was an issue processing your request. Please retry the transaction.',
  '3022':
    'Your card was declined due to insufficient funds. Please ensure you have enough funds or use a different card.',
  '5304': 'The credit card you provided is expired. Please use another card.',
};

export const paysafeErrorMapper: { [key in string]: string } = {
  '3005': errorMessage.InvalidCVV,
  '3006': errorMessage.ExpiredCard,
  '3009': errorMessage.Decline,
  '3012': errorMessage.ExpiredDateCard,
  '3017': errorMessage.CardInvalid,
  '3019': errorMessage.InvalidCVV,
  '5304': errorMessage.ExpiredCard,
};
